import React, { useState, useEffect } from 'react';
import './LoginPromptManager.css';

const LoginPromptManager = ({ 
  userProgress, 
  isLoggedIn, 
  onLogin,
  forceShow = false,
  isDiagnosticMode = false,
  onClose
}) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [promptType, setPromptType] = useState(null);

  // 트리거 조건 체크
  useEffect(() => {
    if (isLoggedIn) return;

    // 10문제 풀이 후 (진단평가 모드에서는 무시)
    if (userProgress.solvedQuestions === 10 && !isDiagnosticMode) {
      setPromptType('progress');
      setShowPrompt(true);
    }
    // 첫 오답 발생
    else if (userProgress.wrongAnswers === 1) {
      setPromptType('wrongAnswer');
      setShowPrompt(true);
    }
    // 30분 사용 후
    else if (userProgress.sessionMinutes >= 30) {
      setPromptType('statistics');
      setShowPrompt(true);
    }
    // 수동 트리거 (추가 조건)
    else if (forceShow) {
      setPromptType('manual');
      setShowPrompt(true);
    }
  }, [userProgress, isLoggedIn, forceShow, isDiagnosticMode]);

  const promptMessages = {
    progress: {
      icon: '📈',
      title: '학습 진도를 저장하시겠습니까?',
      subtitle: '로그인하면 모든 기기에서 이어서 학습할 수 있습니다',
      benefits: [
        '✅ 자동 진도 저장',
        '✅ 다중 기기 동기화',
        '✅ 학습 통계 분석'
      ],
      cta: '3초만에 시작하기'
    },
    wrongAnswer: {
      icon: '📝',
      title: '틀린 문제를 자동으로 관리하세요',
      subtitle: 'AI 오답노트가 당신의 약점을 분석합니다',
      benefits: [
        '🔍 자동 오답 수집',
        '💡 상세 해설 제공',
        '🔄 복습 스케줄링'
      ],
      cta: '오답노트 시작하기'
    },
    statistics: {
      icon: '📊',
      title: '당신의 학습 패턴을 분석해드립니다',
      subtitle: 'AI가 최적의 학습 경로를 제안합니다',
      benefits: [
        '📈 실시간 성적 추이',
        '🎯 취약점 분석',
        '🏆 목표 달성률'
      ],
      cta: '내 통계 확인하기'
    },
    manual: {
      icon: '🔐',
      title: '로그인하고 AI 분석 결과를 확인하세요',
      subtitle: '학습 결과를 바탕으로 맞춤 학습 계획을 제공합니다',
      benefits: [
        '🎯 개인별 취약점 분석',
        '💪 강점 분석 및 활용법',
        '📅 맞춤형 학습 계획',
        '💡 AI 맞춤 학습 조언'
      ],
      cta: '분석 결과 확인하기'
    }
  };

  const message = promptMessages[promptType];

  if (!showPrompt || !message) return null;

  return (
    <div className="login-prompt-overlay">
      <div className="login-prompt-modal">
        <button 
          className="close-btn" 
          onClick={() => {
            setShowPrompt(false);
            onClose && onClose();
          }}
          aria-label="닫기"
        >
          ×
        </button>

        <div className="prompt-header">
          <span className="prompt-icon">{message.icon}</span>
          <h2>{message.title}</h2>
          <p className="subtitle">{message.subtitle}</p>
        </div>

        <div className="benefits-list">
          {message.benefits.map((benefit, idx) => (
            <div key={idx} className="benefit-item">
              {benefit}
            </div>
          ))}
        </div>

        <div className="social-login-section">
          <button 
            className="social-btn google"
            onClick={() => onLogin('google')}
          >
            <img src="/icons/google.svg" alt="Google" />
            <span>Google로 계속하기</span>
          </button>

          <button 
            className="social-btn kakao"
            onClick={() => onLogin('kakao')}
          >
            <img src="/icons/kakao.svg" alt="Kakao" />
            <span>카카오로 계속하기</span>
          </button>

        </div>

        <div className="prompt-footer">
          <button 
            className="guest-login-btn"
            onClick={() => onLogin('guest')}
            style={{
              backgroundColor: '#f3f4f6',
              color: '#374151',
              border: '2px solid #d1d5db',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              marginBottom: '12px',
              width: '100%'
            }}
          >
            🔸 게스트로 먼저 체험하기
          </button>
          <button 
            className="skip-btn"
            onClick={() => {
              setShowPrompt(false);
              onClose && onClose();
            }}
          >
            나중에 하기
          </button>
          <p className="privacy-note">
            가입 시 <a href="/terms">이용약관</a> 및 
            <a href="/privacy">개인정보처리방침</a>에 동의합니다
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptManager;